///<reference path="../model/Sunrise.ts"/>
///<reference path="../model/TideName.ts"/>
///<reference path="../model/TideTime.ts"/>
///<reference path="../../libs/info/imagelogic/NumberTools.ts"/>

namespace app.view{
	import Warn = app.model.Warn;
	import dic = app.model.warn_list;
	import zerofill = info.imagelogic.NumberTools.zerofill;

	export class WarnView {
		public warnData:Warn;

		constructor() {

		}

		private getDate():string{
			return this.warnData.data.date.toString(Const.DATE_WARN);
		}

		private makeArea(area:WarnArea):string{
			let placesStr = '';
			area.places.forEach((elm) => {
				placesStr += this.makePlace(elm);
			});

			let str = `
<h2>${area.name}</h2>
<table>
${placesStr}
</table>
`;
			return str;
		}

		private makePlace(place:WarnPlace):string{
			let warnsStr:string = '';

			place.warn.forEach((elm) => {
				warnsStr += this.makeWarnSpan(elm);

			});
			if(place.warn.length ==0){
				warnsStr = "発表されていません"
			}

			let str = `
<tr>
<th>${place.name}</th>
<td>${warnsStr}</td>
</tr>
`;
			return str;
		}

		private makeWarnSpan(code){
			let type:number,
				name:string,
				typeClass:string

			code = zerofill(code);
			dic.forEach((elm) => {
				if(elm.code == code){
					type = elm.type;
					name = elm.name
				}
			});
			switch(type){
				case 1:
					typeClass = "advisory";
					break;
				case 2:
					typeClass = "warning";
					break;
				case 3:
					typeClass = "danger";
					break;
			}

			return `<span class="${typeClass}">${name}</span>`;
		}

		public makeData():string{
			let areasStr = '';
			this.warnData.data.area.forEach((elm) => {
				areasStr += this.makeArea(elm);
			});


			let str = `
<p class="info">${this.getDate()}</p>
<div class="table-wrapper">
${areasStr}
</div>
`;

			return str;
		}

		public makeError():string{
			let str = `<p>データの取得に失敗しました</p>`;
			return str;
		}

	}

}

